import dynamic from 'next/dynamic';
import { PropsWithChildren } from 'react';

export const AppLayout = dynamic(() => import('./App'), {
  ssr: false,
});

export { Layout as PublicLayout } from './Public';
